module.exports = __webpack_public_path__ + "img/wc-person.png";